export default class Status {
  constructor(icon, titleKeyPostfix, descriptionKeyPostfix) {
    this.icon = icon;
    this.titleKeyPostfix = titleKeyPostfix;
    this.descriptionKeyPostfix = descriptionKeyPostfix;
  }
}
